import {useExternalLinksController} from "../../controllers/externalLinks-controller";
import React, {useEffect} from "react";
import {Button, Dropdown, Empty, Skeleton} from "antd";
import type {MenuProps} from "antd";
import {getImageLink} from "../../helpers/mainHelpers";
import * as BUCKETS from "../../enums/buckets";
import "./style.less"
import {DeleteOutlined, EditOutlined, ExportOutlined, LinkOutlined, MoreOutlined} from "@ant-design/icons";
import {useAuth} from "../../context/authContext";
import AddActionButton from "../action-buttons/addAction-button/AddActionButton";
import ExternalLinkModal from "./components/externalLink-modal/ExternalLinkModal";
import {ExternalLinkItem} from "../../types/links";

const ExternalLinksList = () => {
  const externalLinksController = useExternalLinksController()
  const {
    fetchExternalLinksList,
    externalLinksList,
    isModalOpen,
    toggleModal,
    lastUpdate,
    confirmDelete,
    editButtonHandler,
    isLoading
  } = externalLinksController
  const {canManageContent} = useAuth()

  useEffect(() => {
    fetchExternalLinksList([])
  }, [lastUpdate])

  const getAdminMenu = (externalLink: ExternalLinkItem): MenuProps["items"] => [
    {
      key: "edit",
      icon: <EditOutlined/>,
      label: "Редагувати",
      onClick: () => editButtonHandler(externalLink),
    },
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined/>,
      label: "Видалити",
      onClick: () => externalLink.$id && confirmDelete({id: externalLink.$id}),
    },
  ]

  return <section className="external-links-wrapper" aria-labelledby="useful-links-title">
    <header className="external-links-intro">
      <div>
        <div className="home-section-heading__eyebrow">Корисна інформація</div>
        <h2 className="home-section-heading__title" id="useful-links-title">Офіційні ресурси</h2>
        <p className="external-links-intro__description">
          Перевірені державні та медичні сервіси, які можуть бути вам корисні.
        </p>
      </div>
      {canManageContent && <div className="external-links-intro__add"><AddActionButton size="small" onClick={toggleModal}/></div>}
    </header>

    {isLoading && externalLinksList.length === 0
      ? <div className="external-links-grid external-links-grid--loading" aria-label="Завантаження ресурсів">
        {[0, 1, 2, 3].map((item) => <div className="external-link-skeleton" key={item}>
          <Skeleton.Avatar active size={64} shape="square"/>
          <Skeleton active paragraph={false} title={{width: "72%"}}/>
        </div>)}
      </div>
      : externalLinksList.length === 0
        ? <div className="external-links-empty"><Empty description="Корисні ресурси ще не додано"/></div>
        : <div className={`external-links-grid ${isLoading ? "external-links-grid--updating" : ""}`}>
          {externalLinksList.map((externalLink) => <article className="external-link-card" key={externalLink.$id || externalLink.link}>
            <a className="external-link-card__link" href={externalLink.link} target="_blank" rel="noopener noreferrer"
               aria-label={`${externalLink.title} — відкрити в новій вкладці`}>
              <span className="external-link-card__logo-wrap">
                {externalLink.imageId
                  ? <img
                    src={getImageLink({imageId: externalLink.imageId, bucketId: BUCKETS.MAIN})}
                    alt=""
                    className="external-link-card__logo"
                    loading="lazy"
                  />
                  : <LinkOutlined className="external-link-card__placeholder"/>}
              </span>
              <span className="external-link-card__title">{externalLink.title}</span>
              <span className="external-link-card__action">Перейти на сайт <ExportOutlined/></span>
            </a>

            {canManageContent && <Dropdown menu={{items: getAdminMenu(externalLink)}} trigger={["click"]}>
              <Button className="external-link-card__admin" type="text" shape="circle" icon={<MoreOutlined/>}
                      aria-label={`Керування ресурсом: ${externalLink.title}`}/>
            </Dropdown>}
          </article>)}
        </div>}

    {isModalOpen && <ExternalLinkModal externalLinksController={externalLinksController}/>}
  </section>
}

export default ExternalLinksList
